import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import TeletelRolesIndex from './Index.vue';

/**
 * Teletel roles management. Independent of the Chatwoot Enterprise custom
 * roles page (that one stays paywalled and untouched): different path, route
 * name, component and API.
 *
 * Administrators only. The server enforces the same rule, so hiding the route
 * is a convenience, never the control.
 */
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/teletel-roles'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'teletel_roles', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'teletel_roles',
          meta: {
            permissions: ['administrator'],
          },
          component: TeletelRolesIndex,
        },
      ],
    },
  ],
};
